// Placeholder while we implement.

import * as React from 'react';
import { Typography } from '@bb-ui/react-library/dist/components/Typography';

export const UnderConstruction: React.FunctionComponent = () => (
  <Typography>This isn't implemented yet.</Typography>
);
